module.exports = __webpack_public_path__ + "img/RevoltTV.e15bbb41.png";